module.exports = __webpack_public_path__ + "images/icon/popup_globalSearch-1bc15c0c.svg";